import axios from 'axios';

// Create axios instance with base configuration
// Using relative path to go through Vite proxy
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only handle 401 errors for auth-related endpoints and specific error codes
    if (error.response?.status === 401 && 
        (error.config?.url?.includes('/auth/') || 
         error.response?.data?.code === 'TOKEN_EXPIRED' ||
         error.response?.data?.code === 'INVALID_TOKEN')) {
      localStorage.removeItem('authToken');
      console.log('Auth token expired or invalid, cleared from storage');
    }
    return Promise.reject(error);
  }
);

export { api };
